import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=0b14298f"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/vercel/path0/components/common/Card.vue').default})
